import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { products } from './Products/Products';
import { useCart } from './Cart/CartContext';
import { useParams, Link } from 'react-router-dom';

// Category mapping for Norwegian special characters
const categoryDisplayNames: Record<string, string> = {
  'armband': 'Armpynt',
  'orepynt': 'Ørepynt',
  // Add other category mappings as needed
};

const ProductList: React.FC = () => {
  const { addToCart } = useCart();
  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredProducts, setFilteredProducts] = useState(products);
  const { categorySlug } = useParams<{ categorySlug: string }>();
  
  // Scroll to top when component mounts or categorySlug changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [categorySlug]);
  
  useEffect(() => {
    if (categorySlug) {
      const filtered = products.filter(product => product.category === categorySlug);
      setFilteredProducts(filtered);
    } else {
      setFilteredProducts(products);
    }
  }, [categorySlug]);

  const handleAddToCart = (e: React.MouseEvent, product: any) => {
    e.stopPropagation();
    e.preventDefault();
    addToCart(product);
  };

  const openModal = (product: any) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedProduct(null);
  };

  const categoryName = categorySlug ? 
    (categoryDisplayNames[categorySlug] || categorySlug.charAt(0).toUpperCase() + categorySlug.slice(1)) : 
    "Alle produkter";

  return (
    <section id="produkter" className="mt-5">
      <Helmet>
        <title>{categorySlug ? `${categoryName} | Perler med Vilje` : 'Produkter | Perler med Vilje'}</title>
        <meta name="description" content={categorySlug ? `Oppdag ${categoryName.toLowerCase()} fra Perler med Vilje – håndlagde smykker med mening.` : 'Alle håndlagde perlesmykker: Armbånd, ørepynt og mobilpynt – 25% til Redd Barna.'} />
        <link rel="canonical" href={`https://www.perlermedvilje.no${categorySlug ? `/category/${categorySlug}` : '/products'}`} />
        <meta property="og:title" content={categorySlug ? `${categoryName} | Perler med Vilje` : 'Produkter | Perler med Vilje'} />
        <meta property="og:description" content={categorySlug ? `Se utvalget av ${categoryName.toLowerCase()} fra Perler med Vilje.` : 'Se alle håndlagde smykker og perleprodukter.'} />
        <meta property="og:type" content="website" />
      </Helmet>
      <h2>{categoryName}</h2>
      <div className="row">
        {filteredProducts.map((product) => (
          <div className="col-md-4 mb-4" key={product.id}>
            <Link to={`/product/${product.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div
                className="card"
                style={{ height: '500px', display: 'flex', flexDirection: 'column', cursor: 'pointer' , backgroundColor: 'rgba(248, 150, 165, 0.8)' }}
                onClick={() => openModal(product)}
              >
                <img
                  src={product.image}
                  className="card-img-top"
                  alt={product.name}
                  style={{
                    height: '400px',
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                />
                <div className="card-body" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                  <div>
                    <h5 className="card-title">{product.name}</h5>
                    {/* <p className="card-text">{product.description}</p> */}
                  </div>
                  <div className="mt-auto">
                    <p className="fw-bold">NOK {product.price},-</p>
                    {/*<button*/}
                    {/*  className="btn btn-outline-dark"*/}
                    {/*  onClick={(e) => handleAddToCart(e, product)}*/}
                    {/*>*/}
                    {/*  Legg i handlekurv*/}
                    {/*</button>*/}
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>

      {/* Modal */}
      {isModalOpen && selectedProduct && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
          tabIndex={-1}
        >
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedProduct.name}</h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-body">
                <img
                  src={selectedProduct.image}
                  alt={selectedProduct.name}
                  style={{ width: '100%', height: 'auto' }}
                />
                <p>{selectedProduct.description}</p>
                <p className="fw-bold">NOK{selectedProduct.price}</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  Lukk
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductList;